import { data } from '../../svg/ContentCopy/data';
import { makeIcon } from '../makeIcon';

export const ContentCopy = makeIcon(data, 'content_copy', 'ContentCopy');

export default ContentCopy;
